"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullAccessCard = exports.CardWithTab = exports.CardWithActionItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _atoms = require("../../../atoms");

var _carditem = require("../carditem");

var _style = require("./style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** Full Access Card */
const FullAccessCard = ({
  heading,
  data,
  width,
  height,
  onItemClick,
  children,
  ...props
}) => {
  return /*#__PURE__*/_react.default.createElement(_style.StyledCard, _extends({}, props, {
    width: width,
    height: height
  }), /*#__PURE__*/_react.default.createElement(_style.StyledCardHeading, null, heading), children ? children : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data.length > 0 && data.map((obj, i) => /*#__PURE__*/_react.default.createElement(_carditem.GeneralItem, _extends({
    key: i
  }, obj, {
    onClick: () => onItemClick(obj)
  })))));
};

exports.FullAccessCard = FullAccessCard;
FullAccessCard.defaultProps = {
  width: '300px'
};
FullAccessCard.propTypes = {
  /**  card heading  */
  heading: _propTypes.default.string,

  /** width of card*/
  width: _propTypes.default.string,

  /** height of card*/
  height: _propTypes.default.string,

  /** pass data as a prop with same structure */
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    subtitle: _propTypes.default.string,
    imgUrl: _propTypes.default.string,
    imgAltText: _propTypes.default.string
  })),

  /** use children for custom content */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),

  /** handler function for item arrow clicking */
  onItemClick: _propTypes.default.func
};
/** Card with Action Items */

const CardWithActionItem = ({
  heading,
  data,
  width,
  height,
  onItemClick,
  showArrow,
  children,
  ...props
}) => {
  return /*#__PURE__*/_react.default.createElement(_style.StyledCard, _extends({}, props, {
    width: width,
    height: height
  }), /*#__PURE__*/_react.default.createElement(_style.StyledCardHeading, null, heading), children ? children : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data && data.length > 0 && data.map((obj, i) => /*#__PURE__*/_react.default.createElement(_carditem.ActionItem, _extends({
    key: i
  }, obj, {
    onItemClick: onItemClick,
    showArrow: showArrow
  })))));
};

exports.CardWithActionItem = CardWithActionItem;
CardWithActionItem.defaultProps = {
  showArrow: true,
  width: '337px'
};
CardWithActionItem.propTypes = {
  /**  card heading  */
  heading: _propTypes.default.string,

  /** width of card*/
  width: _propTypes.default.string,

  /** height of card*/
  height: _propTypes.default.string,

  /** pass data as a prop with same structure */
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
    subtitle: _propTypes.default.string,
    imgUrl: _propTypes.default.string,
    imgAltText: _propTypes.default.string
  })),
  showArrow: _propTypes.default.bool,

  /** use children for custom content */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),

  /** handler function for item arrow clicking */
  onItemClick: _propTypes.default.func
};
/** Card with Tab */

const CardWithTab = ({
  heading,
  data,
  width,
  height,
  onItemClick,
  showArrow,
  children,
  tabChangeCustomHandler,
  ...props
}) => {
  return /*#__PURE__*/_react.default.createElement(_style.StyledCard, _extends({}, props, {
    width: width,
    height: height
  }), /*#__PURE__*/_react.default.createElement(_style.StyledCardHeading, {
    className: "card-heading"
  }, heading), children ? children : data && data.length > 0 && /*#__PURE__*/_react.default.createElement(_atoms.Tab, {
    navClassName: "tab-mb",
    tabChangeHandler: tabChangeCustomHandler
  }, data.map((obj, i) => /*#__PURE__*/_react.default.createElement(_atoms.TabItem, {
    key: i,
    title: obj.tabName
  }, obj.render !== undefined ? obj.render() : obj.data.length > 0 && obj.data.map((item, j) => /*#__PURE__*/_react.default.createElement(_carditem.ActionItem, _extends({
    key: j
  }, item, {
    onItemClick: onItemClick,
    showArrow: showArrow
  })))))));
};

exports.CardWithTab = CardWithTab;
CardWithTab.defaultProps = {
  showArrow: true,
  width: '337px'
};
CardWithTab.propTypes = {
  /**  card heading  */
  heading: _propTypes.default.string,

  /** width of card*/
  width: _propTypes.default.string,

  /** height of card*/
  height: _propTypes.default.string,

  /** pass data as a prop with same structure */
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    tabName: _propTypes.default.string,
    data: _propTypes.default.arrayOf(_propTypes.default.shape({
      title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
      subtitle: _propTypes.default.string,
      imgUrl: _propTypes.default.string,
      imgAltText: _propTypes.default.string
    }))
  })),
  showArrow: _propTypes.default.bool,

  /** use children for custom content */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),

  /** handler function for item arrow clicking */
  onItemClick: _propTypes.default.func,

  /** handler function for extending functionality on tab change */
  tabChangeCustomHandler: _propTypes.default.func
};